/*
 * Is a real mouse in use?
 *
 * Not @media ( hover: hover ): iPadOS Safari answers no to that even when a trackpad
 * or a mouse is attached, so an iPad would never get any hover behaviour. <html> is
 * marked with .has-mouse once a mouse actually turns up instead, and the CSS hangs
 * off that class.
 *
 * Phones are left out: there is no pointer to attach to one, and iOS fires
 * mouse-shaped compatibility events after a tap that would otherwise look like one.
 */

const phone = window.matchMedia('(max-width: 44.9375rem)');
const isPhone = () => navigator.maxTouchPoints > 0 && phone.matches;

const waiting: Array<() => void> = [];
let mouseInUse = false;

export const hasMouse = () => mouseInUse;

/* Run fn now if a mouse is already in use, otherwise as soon as one turns up. */
export const onMouse = (fn: () => void) => {
  if (mouseInUse) fn();
  else waiting.push(fn);
};

const useMouse = () => {
  if (mouseInUse || isPhone()) return;

  mouseInUse = true;
  document.documentElement.classList.add('has-mouse');
  waiting.splice(0).forEach((fn) => fn());
};

// a desktop browser answers yes here, and behaves as it always did from the first frame
if (navigator.maxTouchPoints === 0 && window.matchMedia('(any-hover: hover)').matches) useMouse();

// everywhere else a mouse proves itself by moving about; one stray event isn't enough
let moves = 0;

window.addEventListener('pointermove', (event) => {
  if (event.pointerType !== 'mouse') return;

  moves += 1;
  if (moves >= 3) useMouse();
});
